import { SelectedData } from '../../../../../../../../components/ListPicker/useOptimisticListPick.types';
import { PackQuantitiesWithMultiplier } from '../../../../../../../../services/modules/product-colors-packs/product-colors-packs.types';
import { PackWithError } from '../../../../../../../products/details/productDetails.types';
import {
  GetSelectedPacksOnClickGridMultiplyProps,
  GetSelectedPacksOnClickRowProps,
} from '../types/orderProductPacksMenu.types';

export const isPackSelected = (
  selectedData: SelectedData<PackQuantitiesWithMultiplier>,
  pack: PackQuantitiesWithMultiplier,
) => {
  const selected =
    !!selectedData.currentItems.find((currentItem) => currentItem.id === pack.id) ||
    !!selectedData.newItems.find((newItem) => newItem.id === pack.id);
  return selected;
};

export const isPackWithError = (
  packsWithError: PackWithError[],
  pack: PackQuantitiesWithMultiplier,
) => packsWithError.some((packWithError) => packWithError.id === pack.id);

export const isPackWithUnavailableStock = (
  packsWithUnavailableStock: PackWithError[],
  pack: PackQuantitiesWithMultiplier,
) =>
  packsWithUnavailableStock.some(
    (packWithUnavailableStock) => packWithUnavailableStock.id === pack.id,
  );

export const getSelectedPacksOnClickRow = ({
  pack,
  multiplier,
  selectedData,
  packSelected,
}: GetSelectedPacksOnClickRowProps): PackQuantitiesWithMultiplier[] => {
  const selecteds = [...selectedData.currentItems, ...selectedData.newItems];
  if (packSelected) {
    return selecteds.filter((selectedPack) => selectedPack.id !== pack.id);
  } else {
    selecteds.push({ ...pack, multiplier });
    return selecteds;
  }
};

export const getSelectedPacksOnClickGridMultiply = ({
  pack,
  multiplier,
  selectedData,
  packSelected,
  mustRemovePackItem,
  mustUpdatePackItem,
}: GetSelectedPacksOnClickGridMultiplyProps): PackQuantitiesWithMultiplier[] => {
  const selecteds = [...selectedData.currentItems, ...selectedData.newItems];
  if (mustRemovePackItem) {
    return selecteds.filter((selectedPack) => selectedPack.id !== pack.id);
  }
  if (mustUpdatePackItem) {
    const filtered = selecteds.filter((selectedPack) => selectedPack.id !== pack.id);
    filtered.push({ ...pack, multiplier });
    return filtered;
  }
  if (!packSelected) {
    selecteds.push({ ...pack, multiplier });
    return selecteds;
  }
  return selecteds;
};
